import { Instagram } from 'lucide-react';

export default function Footer() {
    return (
        <footer className="border-t border-champagne/40 px-6 py-12" data-testid="footer-container">
            <div className="mx-auto flex max-w-5xl flex-col items-center gap-6 text-center">
                <img
                    src="/assets/phoenix.png"
                    alt="Phénix Éclora"
                    className="w-16 mix-blend-multiply"
                    loading="lazy"
                    data-testid="footer-logo"
                />
                <p className="font-sans text-xs font-medium uppercase tracking-[0.4em] text-bordeaux">Mon Éclora</p>

                <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3" aria-label="Liens de pied de page">
                    <a
                        href="https://www.instagram.com/mon.eclora/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-cacao/70 transition-colors duration-300 hover:text-bordeaux"
                        data-testid="footer-instagram-link"
                    >
                        <Instagram className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" />
                        Instagram
                    </a>
                    <a
                        href="/mentions-legales"
                        className="text-xs uppercase tracking-[0.2em] text-cacao/70 transition-colors duration-300 hover:text-bordeaux"
                        data-testid="footer-legal-link"
                    >
                        Mentions légales
                    </a>
                    <a
                        href="/politique-de-confidentialite"
                        className="text-xs uppercase tracking-[0.2em] text-cacao/70 transition-colors duration-300 hover:text-bordeaux"
                        data-testid="footer-privacy-link"
                    >
                        Politique de confidentialité
                    </a>
                </nav>

                <p className="text-xs text-cacao/50">© 2026 Mon Éclora</p>
            </div>
        </footer>
    );
}
